module.exports = __webpack_public_path__ + "img/book9.b007568b.jpg";